import { BaseError } from './BaseError.js';

const REQUEST_CONTEXT_ERROR_CODE = 2000;
class RequestContextError extends BaseError {
  constructor() {
    super('RequestContextError', REQUEST_CONTEXT_ERROR_CODE);
  }
}

export { REQUEST_CONTEXT_ERROR_CODE, RequestContextError };
//# sourceMappingURL=RequestContextError.js.map
